import { vservice } from '@niknevis/vue-modules'
import { BaseRequestLoadingHandler } from '@/modules/shared/interfaces/base-request-loading-handler.interface'
import { AdminDepositBankAccountService } from '@/modules/deposit-bank-account/services/admin-deposit-bank-account.service'
import { DepositBankAccountRequestModel } from '@/modules/deposit-bank-account/models/deposit-bank-account-request.model'

@vservice()
export class AdminUpdateDepositBankAccountUseCase implements BaseRequestLoadingHandler {
  constructor(
    private service: AdminDepositBankAccountService
  ) {
  }

  private loadingState: boolean = false

  private successState: boolean = false

  get isLoading() {
    return this.loadingState
  }

  get isSuccess() {
    return this.successState
  }

  execute(accountId: number, data: DepositBankAccountRequestModel) {
    return this.service.updateDepositBankAccount(accountId, data)
      .onStart(() => {
        this.loadingState = true
        this.successState = false
      })
      .onFinish(() => {
        this.loadingState = false
      })
      .onSuccess(() => {
        this.successState = true
      })
  }
}
